import { render, staticRenderFns } from "./userTableLayer.vue?vue&type=template&id=5e380f2a&scoped=true&"
import script from "./userTableLayer.vue?vue&type=script&lang=js&"
export * from "./userTableLayer.vue?vue&type=script&lang=js&"
import style0 from "./userTableLayer.vue?vue&type=style&index=0&id=5e380f2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e380f2a",
  null
  
)

export default component.exports